import React from 'react';

export type MetricCardData = {
  label: string;
  tooltipInfo: React.ReactNode;
  value: string | number;
  key: string;
};
